import { jsx as _jsx } from "react/jsx-runtime";
import Circular from '@mui/material/CircularProgress';
import clsx from 'clsx';
import { memo } from 'react';
import useStyles from './styles';
var ButtonSpinner = function (_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 36 : _b;
    var styles = useStyles();
    return _jsx(Circular, { className: clsx(className, styles.spinner), size: size });
};
export default memo(ButtonSpinner);
//# sourceMappingURL=ButtonSpinner.js.map